import React from "react";
import {
  MdDashboard,
  MdPeople,
  MdViewModule,
  MdBusiness,
  MdShield,
  MdEmail,
  MdAdminPanelSettings,
  MdOutlineMap,
  MdFlight,
  MdAutorenew,
  MdFlightTakeoff,
  MdTableView,
  MdMessage,
  MdHistory,
  MdCampaign,
  MdReceipt,
  MdGavel,
  MdAccountBalance,
} from "react-icons/md";

export type DashboardMenuItem = {
  key: string;
  label: string;
  route: string;
  icon: React.ComponentType<any>;
  color: string;
  order: number;
  group: string;
  prod: boolean;
  permissionsAny?: string[];
};

const aircraftAvailableIcon = MdFlight;
const aircraftWantedIcon = MdFlightTakeoff;

const AIRCRAFT_COLOR_AOG = "#EF4444";
const AIRCRAFT_COLOR_AVAILABLE = "#22C55E";
const AIRCRAFT_COLOR_WANTED = "#3B82F6";

export const DASHBOARD_MENU: DashboardMenuItem[] = [
  {
    key: "dashboard",
    label: "Dashboard",
    route: "/dashboard/overview",
    icon: MdDashboard,
    color: "#6366F1",
    order: 1,
    group: "System",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN", "SYSTEM_AUDIT"],
  },
  {
    key: "users",
    label: "User Managment",
    route: "/dashboard/users",
    icon: MdPeople,
    color: "#22C55E",
    order: 2,
    group: "User & Company",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN", "USER_VIEW"],
  },
  {
    key: "modules",
    label: "Module Managment",
    route: "/dashboard/modules",
    icon: MdViewModule,
    color: "#0EA5E9",
    order: 3,
    group: "System",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN"],
  },

  {
    key: "subscription",
    label: "Subscription Managment",
    route: "/dashboard/subscriptions",
    icon: MdViewModule,
    color: "#e90ec5ff",
    order: 4,
    group: "User & Company",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN"],
  },
  {
    key: "company-balances",
    label: "Company Item Balances (Ekstra Hak)",
    route: "/dashboard/company-package-item-balances",
    icon: MdAccountBalance,
    color: "#F59E0B",
    order: 5,
    group: "User & Company",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN"],
  },

  {
    key: "email-templates",
    label: "Email Templates Managment",
    route: "/dashboard/email-template",
    icon: MdEmail,
    color: "#F97316",
    order: 4,
    group: "Communication",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN"],
  },

  {
    key: "reservation-request-types",
    label: "Reservation Request Type Managment",
    route: "/dashboard/reservation-request-types",
    icon: MdTableView,
    color: "#41a9eeff",
    order: 100,
    group: "System",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN"],
  },

  {
    key: "aircraft-define",
    label: "AirCraft Managment",
    route: "/dashboard/aircraft-define-types",
    icon: MdFlight,
    color: "#b10aa3ff",
    order: 100,
    group: "Aviation",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN"],
  },

  {
    key: "company-list",
    label: "Companies Managment",
    route: "/dashboard/company-list",
    icon: MdBusiness,
    color: "#8B5CF6",
    order: 5,
    group: "User & Company",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN"],
  },

  {
    key: "location-list",
    label: "Location Managment",
    route: "/dashboard/location-list",
    icon: MdOutlineMap,
    color: "#8B5CF6",
    order: 6,
    group: "System",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN"],
  },

  {
    key: "permissions",
    label: "Permissions Managment",
    route: "/dashboard/permissions-table",
    icon: MdShield,
    color: "#DC2626",
    order: 7,
    group: "System",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN"],
  },

  {
    key: "roles",
    label: "Roles Managment",
    route: "/dashboard/roles",
    icon: MdShield,
    color: "#DC2626",
    order: 8,
    group: "System",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN"],
  },

  {
    key: "roles-permissions",
    label: "User Roles Managment",
    route: "/dashboard/roles-permissions",
    icon: MdShield,
    color: "#DC2626",
    order: 9,
    group: "System",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN"],
  },

  {
    key: "dynamic-page",
    label: "Dynamic Pages Managment",
    route: "/dashboard/dynamic-page",
    icon: MdTableView,
    color: "#d807bcff",
    order: 10,
    group: "System",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN"],
  },

  {
    key: "engine-type",
    label: "Engine Type Managment",
    route: "/dashboard/engine-type",
    icon: MdTableView,
    color: "rgb(14, 185, 134)",
    order: 11,
    group: "Aviation",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN"],
  },

  {
    key: "banner-page",
    label: "Banners Managment",
    route: "/dashboard/banners",
    icon: MdTableView,
    color: "#0eb8e2ff",
    order: 12,
    group: "Communication",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN"],
  },

  {
    key: "chat",
    label: "Chat",
    route: "/dashboard/chat",
    icon: MdMessage,
    color: "#25D366",
    order: 30,
    group: "Communication",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN", "USER_VIEW"],
  },
  {
    key: "email-logs",
    label: "Email Logs",
    route: "/dashboard/email-logs",
    icon: MdHistory,
    color: "#F59E0B",
    order: 31,
    group: "Communication",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN"],
  },

  {
    key: "marketing-emails",
    label: "Marketing Emails",
    route: "/dashboard/marketing-emails",
    icon: MdCampaign,
    color: "#8B5CF6",
    order: 32,
    group: "Communication",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN"],
  },
  {
    key: "invoices",
    label: "Invoices",
    route: "/dashboard/invoices",
    icon: MdReceipt,
    color: "#6366F1",
    order: 33,
    group: "User & Company",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN"],
  },

  {
    key: "pending-listings",
    label: "Pending Listings",
    route: "/dashboard/pending-listings",
    icon: MdFlightTakeoff,
    color: "#F59E0B",
    order: 19,
    group: "Aviation",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN"],
  },

  {
    key: "expired-listings",
    label: "Expired Listings",
    route: "/dashboard/expired-listings",
    icon: MdAutorenew,
    color: "#DC2626",
    order: 19.5,
    group: "Aviation",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN"],
  },

  {
    key: "aircraft-wetlease-aog",
    label: "Aircraft Wet Lease AOG",
    route: "/dashboard/aircraft/wet-lease/aog",
    icon: aircraftAvailableIcon,
    color: AIRCRAFT_COLOR_AOG,
    order: 20,
    group: "Aviation",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN"],
  },

  {
    key: "aircraft-wetlease-listing",
    label: "Aircraft Wet Lease Available",
    route: "/dashboard/aircraft/wet-lease/listing",
    icon: aircraftAvailableIcon,
    color: AIRCRAFT_COLOR_AVAILABLE,
    order: 21,
    group: "Aviation",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN"],
  },

  {
    key: "aircraft-wetlease-wanted",
    label: "Aircraft Wet Lease Wanted",
    route: "/dashboard/aircraft/wet-lease/wanted",
    icon: aircraftWantedIcon,
    color: AIRCRAFT_COLOR_WANTED,
    order: 22,
    group: "Aviation",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN"],
  },

  {
    key: "aircraft-sale-lease-listing",
    label: "Aircraft Sale/Lease Available",
    route: "/dashboard/aircraft/salelease/listing",
    icon: aircraftAvailableIcon,
    color: AIRCRAFT_COLOR_AVAILABLE,
    order: 23,
    group: "Aviation",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN"],
  },

  {
    key: "aircraft-sale-wanted",
    label: "Aircraft Sale/Lease Wanted",
    route: "/dashboard/aircraft/salelease/wanted",
    icon: aircraftWantedIcon,
    color: AIRCRAFT_COLOR_WANTED,
    order: 24,
    group: "Aviation",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN"],
  },

  {
    key: "BusinessJetSaleLeaseRentalAvailables",
    label: "Business Jet Sale/Lease/Rental Availables",
    route: "/dashboard/business-jet/listing",
    icon: aircraftAvailableIcon,
    color: AIRCRAFT_COLOR_AVAILABLE,
    order: 25,
    group: "Aviation",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN"],
  },

  {
    key: "BusinessJetSaleLeaseRentalWanteds",
    label: "Business Jet Sale/Lease/Rental Wanted",
    route: "/dashboard/business-jet/wanted",
    icon: aircraftWantedIcon,
    color: AIRCRAFT_COLOR_WANTED,
    order: 26,
    group: "Aviation",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN"],
  },

  {
    key: "AircraftCharterWanted",
    label: "Aircraft Charter Wanted",
    route: "/dashboard/aircraft-charter/wanted",
    icon: aircraftWantedIcon,
    color: AIRCRAFT_COLOR_WANTED,
    order: 27,
    group: "Aviation",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN"],
  },

  {
    key: "AircraftCharterAvailable",
    label: "Aircraft Charter Available",
    route: "/dashboard/aircraft-charter/listing",
    icon: aircraftAvailableIcon,
    color: AIRCRAFT_COLOR_AVAILABLE,
    order: 28,
    group: "Aviation",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN"],
  },

  {
    key: "aircraft-organize-request",
    label: "Aircraft Requests",
    route: "/dashboard/aircraft/requests",
    icon: MdTableView,
    color: "#41a9eeff",
    order: 29,
    group: "Aviation",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN"],
  },


  {
    key: "engine-sale-listing",
    label: "Engine Sale/Lease Available",
    route: "/dashboard/engine/salelease/listing",
    icon: aircraftAvailableIcon,
    color: AIRCRAFT_COLOR_AVAILABLE,
    order: 40,
    group: "Aviation",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN"],
  },

  {
    key: "engine-sale-wanted",
    label: "Engine Sale/Lease Wanted",
    route: "/dashboard/engine/salelease/wanted",
    icon: aircraftWantedIcon,
    color: AIRCRAFT_COLOR_WANTED,
    order: 41,
    group: "Aviation",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN"],
  },


  {
    key: "tenders",
    label: "Tender Management",
    route: "/dashboard/tenders",
    icon: MdGavel,
    color: "#7C3AED",
    order: 42,
    group: "Aviation",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN"],
  },
  {
    key: "settings",
    label: "App Settings",
    route: "/dashboard/settings",
    icon: MdAdminPanelSettings,
    color: "#EF4444",
    order: 99,
    group: "System",
    prod: false,
    permissionsAny: ["SYSTEM_ADMIN"],
  },
  {
    key: "local-support",
    label: "Local Support Requests",
    route: "/dashboard/addons/local-support",
    icon: MdTableView,
    color: "#3B82F6",
    order: 50,
    group: "Communication",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN"],
  },
  {
    key: "legal-support",
    label: "Legal Support Requests",
    route: "/dashboard/addons/legal-support",
    icon: MdTableView,
    color: "#8B5CF6",
    order: 51,
    group: "Communication",
    prod: true,
    permissionsAny: ["SYSTEM_ADMIN"],
  },
];

export const filterMenuByPermissions = (
  menu: DashboardMenuItem[],
  owned: string[]
): DashboardMenuItem[] => {
  const set = new Set(owned || []);
  const isAdmin = set.has("SYSTEM_ADMIN");

  return menu
    .filter((m) => {
      if (!m.permissionsAny || m.permissionsAny.length === 0) return true;
      if (isAdmin) return true;
      return m.permissionsAny.some((p) => set.has(p));
    })
    .sort((a, b) => a.order - b.order);
};
